// extracted by css-extract-rspack-plugin
export default {"refineMenuContainer":"_5c6bef4b"};